import cn from 'classnames'
import React, { ComponentProps } from 'react'

type PolicyInsightThumbsUpIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function PolicyInsightThumbsUpIcon(
  props: PolicyInsightThumbsUpIconProps,
) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('PolicyInsightThumbsUpIcon', className)}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      <path d="M5.4012 13.3332V7.4665M2.66669 8.53317V12.2665C2.66669 12.8556 3.1564 13.3332 3.76049 13.3332H11.1033C11.9131 13.3332 12.6018 12.757 12.725 11.9765L13.3139 8.24313C13.4668 7.27392 12.6979 6.39984 11.6923 6.39984H9.77641C9.47436 6.39984 9.22951 6.16106 9.22951 5.8665V3.98162C9.22951 3.2553 8.62573 2.6665 7.88094 2.6665C7.70329 2.6665 7.5423 2.76853 7.47016 2.92684L5.54554 7.14978C5.45777 7.34238 5.26191 7.4665 5.04578 7.4665H3.76049C3.1564 7.4665 2.66669 7.94407 2.66669 8.53317Z" />
    </svg>
  )
}
